import { render, staticRenderFns } from "./VChatBox.vue?vue&type=template&id=4f0ff003&scoped=true"
import script from "./VChatBox.vue?vue&type=script&lang=ts"
export * from "./VChatBox.vue?vue&type=script&lang=ts"
import style0 from "./VChatBox.vue?vue&type=style&index=0&id=4f0ff003&prod&lang=scss&scoped=true"
import style1 from "./VChatBox.vue?vue&type=style&index=1&id=4f0ff003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ff003",
  null
  
)

export default component.exports